import { Injectable } from '@angular/core';
import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';

/** Default ceiling for any request that doesn't ask for its own. */
export const DEFAULT_HTTP_TIMEOUT = 20000;

/**
 * Per-request timeout override, in milliseconds.
 *
 * Raise it only for an endpoint that can legitimately outrun the default, and
 * only where abandoning the request is worse than waiting: the browser giving
 * up does NOT cancel the work server-side, so a write that is still committing
 * surfaces as a failure the customer may then retry against a change that
 * already landed.
 *
 * ```ts
 * http.put(url, body, { context: new HttpContext().set(HTTP_TIMEOUT, 120000) })
 * ```
 */
export const HTTP_TIMEOUT = new HttpContextToken<number>(() => DEFAULT_HTTP_TIMEOUT);

/**
 * Timeout Interceptor
 *
 * Applies a 20-second timeout to all HTTP requests, unless the request carries
 * an HTTP_TIMEOUT override. Matches the default timeout behavior of
 * HttpClientCustom.
 */
@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      timeout(req.context.get(HTTP_TIMEOUT))
    );
  }
}
